import { Component, AfterViewInit, ViewChild, Input } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AppTableComponent, RequestsService, Auth, TranslationManager, RequestStatusUniqueIdentifier, MessagesComponent, OpnTeamMemberModel, ViewState } from "src/common";
import { OpnBoardMembersListService, OpnBoardMembersListModel } from "src/common/services/requests/opn-steps/opn-boardmembers-list";
import { RequestBasicInformationComponent } from "../../request-basic-information/request-basic-information.component";
import { OpnBoardMemberListComponent } from "./opn-boardmember-list";


@Component({
  selector: 'opn-boardmembers-list',
  templateUrl: 'opn-boardmembers-list.component.html'
})

export class OpnBoardMembersListComponent implements AfterViewInit {

  @ViewChild(AppTableComponent) appTable: AppTableComponent;
  @Input() requestId: number;
  @Input() state: ViewState;
  viewState = ViewState;

  @ViewChild('requestBasicInformationComponent') requestBasicInformationComponent: RequestBasicInformationComponent;
  @ViewChild("opnBoardMemberListComponent") opnBoardMemberListComponent: OpnBoardMemberListComponent;

  constructor(private requestService: RequestsService,
    private opnBoardMembersListService: OpnBoardMembersListService,
    private router: Router,
    private route: ActivatedRoute) { }

  items: OpnBoardMembersListModel[];
  idForDelete: number;
  showDeleteModal: boolean = false;
  auth = Auth;

  translationManager = TranslationManager;
  requestStatusUniqueIdentifier = RequestStatusUniqueIdentifier;
  requestStatus: string;
  deadlineForCompletion: Date;

  ngOnInit(): void {
    this.requestService.getRequestStatusUnique(this.requestId).then(result => {
      this.requestStatus = result.requestStatus;
    });

    this.requestService.deadlineForCompletion(this.requestId).then(result => {
      this.deadlineForCompletion = result.deadlineForCompletion;
    });

  }

  ngAfterViewInit(): void {
    // this.appTable.onSearch = this.doSearch.bind(this);
    // this.appTable.search();
    this.getAll();
  }


  // doSearch(search: SearchModel) {
  //   this.requestService.opnBoardMembersListSearch(search, this.requestId).then((result: SearchResultModel<OpnBoardMembersListModel>) => {
  //     this.items = result.items;
  //     // this.appTable.setTotalCount(result.totalCount);
  //   });
  // }


  getAll() {
    this.requestService.opnBoardMembersListGetAll(this.requestId).then(result => {
      this.items = result;
    })
  }

  showCreateModal() {
    this.opnBoardMemberListComponent.createModal(this.requestId).then((success: boolean) => {
      if (success) {
        this.getAll();
        MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно сачувани')]);
      }
    });
  }

  showDeleteModalFor(id: number) {
    this.idForDelete = id;
    this.showDeleteModal = true;
  }

  delete() {
    if (this.idForDelete > 0) {
      this.opnBoardMembersListService.delete(this.idForDelete).then(() => {
        this.idForDelete = 0;
        this.showDeleteModal = false;
        this.getAll();
        MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно обрисани')]);
      }).catch((reason: any) => {
        MessagesComponent.instance.showError([reason.error.messages]);
      });
    }
  }
}
